export const SEARCH_LOCAL_STORAGE_ID = {
    searchSource: 'searchSource',
    newRecentSearches: 'newRecentSearches',
    searchResults: 'searchResults',
};
